import React from 'react';
import { BiPhoneCall } from 'react-icons/bi';
import { HiMapPin } from "react-icons/hi2";
import { clinicLocation } from '../../../config';

const ContactHeader = () => {
  return (
    <div className="hidden lg:flex lg:bg-darkBackground text-white py-2 ">
      <div className="flex mx-10 w-full justify-between items-center">
        {/* Flashing "Opening Soon!" text */}
        <div className="text-sm font-bold text-red-500 animate-flash">OPEN NOW!</div>

        <div className="space-x-6 flex">
          <a href={"tel:+1 (226) 368-1309"} className=" text-sm flex items-center"><BiPhoneCall className='mx-2'/> +1 (226) 368-1309</a>
          <a href={clinicLocation} target='_blank' rel="noopener noreferrer" className="text-sm flex items-center"><HiMapPin className='mx-2'/> 360 Conklin Rd Unit A2, Brantford, ON N3T 0N5</a>
        </div>
      </div>
    </div>
  );
};

export default ContactHeader;